import React from "react";
import { Link } from "react-router-dom";
import { Ticket, Lifebuoy } from "@phosphor-icons/react";
import { useSettings } from "@/context/SettingsContext";
import { pick } from "@/lib/languages";
import { homeL } from "@/i18n/home";

// Two facts about booking here, each true today: a booking is found again
// with an email and its number (pages/ManageBooking), and the support form
// takes that number (pages/Support). Nothing about prices, guarantees or
// other travellers. The line about paying by Stripe was removed (owner,
// 2026-10-05).
const FACTS = [
  { key: "manage", icon: Ticket, to: "/manage" },
  { key: "support", icon: Lifebuoy, to: "/support" },
];

/** One pale strip of two facts, divided by a hairline: not two cards. */
export default function TrustStrip() {
  const { lang, siteLang = lang } = useSettings();
  const l = pick(homeL, siteLang).trust;
  return (
    <section aria-labelledby="home-trust-title" data-testid="home-trust" className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
      <h2 id="home-trust-title" className="sr-only">{l.title}</h2>
      <ul className="grid divide-y divide-touki rounded-lg bg-touki-light md:grid-cols-2 md:divide-x md:divide-y-0 rtl:md:divide-x-reverse">
        {FACTS.map(({ key, icon: Icon, to }) => (
          <li key={key} className="flex gap-3 p-4 md:p-4 lg:p-5" data-testid={`trust-${key}`}>
            <Icon size={24} weight="regular" aria-hidden="true" className="mt-0.5 shrink-0 text-touki-black" />
            <div className="min-w-0">
              <p className="text-heading-sm font-bold text-touki-black">{l[key].title}</p>
              <p className="mt-1 text-body-sm text-touki-muted text-pretty">{l[key].body}</p>
              {to ? (
                <Link to={to} className="mt-1 inline-flex min-h-11 items-center text-label-lg font-semibold text-touki-black underline decoration-touki-field underline-offset-4 transition-colors duration-fast hover:decoration-touki-black">
                  {l[key].link}
                </Link>
              ) : null}
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
